import moment from 'moment';
import { FC } from 'react';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../shared/dialog/dialog.styles';
import { withPatientIvStatusDialogProvider } from '../../hooks/use-patient-iv-status-dialog/hoc';
import { usePatientIvStatusDialog } from '../../hooks/use-patient-iv-status-dialog/hook';
import { PatientIvStatusDialog } from '../patient-iv-status-dialog';
import { AppointmentEndedMessage } from '../shared/appointment-ended-message/appointment-ended-message';
import { ManuallyVerifiedButton } from '../shared/manually-verified-button';
import { SelfPayButton } from '../shared/self-pay-button';
import { BoldText } from '../styles';

const RetryInProgressStatusDialog: FC = () => {
  const { opened, onClose, isLoading, selectedIvSummary, patientInfo, appointment } = usePatientIvStatusDialog();

  return (
    <PatientIvStatusDialog
      opened={opened}
      title="Retry in Progress"
      subtitle={
        <>
          <BoldText>{`${patientInfo?.firstName} ${patientInfo?.lastName}`}</BoldText>
          {selectedIvSummary?.dateSubmitted && (
            <>&nbsp;- Started {moment.utc(selectedIvSummary.dateSubmitted).local().format('MMM D hA')}</>
          )}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '30px 0 20px 0', display: 'block' }}>
        The payer's systems are currently not responding. We will continue to retry the verification for up to 5 hours.
      </DialogSubTitle>
      <AppointmentEndedMessage />
      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </PatientIvStatusDialog>
  );
};

export default withPatientIvStatusDialogProvider(RetryInProgressStatusDialog);
